import React, { useState } from 'react';
import { Music, Volume2, VolumeX, Zap } from 'lucide-react';
import { getAudio, setAudio } from './wbMusic';
import { wbSfx } from './wbSfx';

const Row = ({ icon: Icon, label, on, onToggle, testid }) => (
  <button onClick={onToggle} data-testid={testid} className="flex w-full items-center gap-2 py-1.5 text-left">
    <Icon className={`h-4 w-4 ${on ? 'text-amber-300' : 'text-purple-400/60'}`} />
    <span className="flex-1 text-[12px] font-black text-purple-50">{label}</span>
    <span className={`relative h-5 w-9 rounded-full transition-colors ${on ? 'bg-amber-400' : 'bg-purple-900'}`}>
      <i className={`absolute top-0.5 h-4 w-4 rounded-full bg-white transition-all ${on ? 'left-[18px]' : 'left-0.5'}`} />
    </span>
  </button>
);

/* Menu de som do HUD: música ligada/volume e efeitos. Persistido no navegador. */
export const WbAudioMenu = ({ onChange }) => {
  const [cfg, setCfg] = useState(getAudio());
  const upd = (patch) => { const c = setAudio(patch); setCfg(c); onChange?.(c); };
  const allOff = !cfg.musicOn && !cfg.sfxOn;
  return (
    <div className="w-60 rounded-2xl border border-purple-500/40 bg-[#140a24]/95 p-3 shadow-2xl backdrop-blur" data-testid="wb-audio-menu">
      <p className="mb-1 text-[10px] font-black uppercase tracking-[.2em] text-purple-300/80">Som da vila</p>
      <Row icon={Music} label="Música de fundo" on={cfg.musicOn} onToggle={() => upd({ musicOn: !cfg.musicOn })} testid="wb-audio-music" />
      <input type="range" min={0} max={1} step={0.05} value={cfg.musicVol} disabled={!cfg.musicOn} data-testid="wb-audio-music-vol"
        onChange={(e) => upd({ musicVol: Number(e.target.value) })} className="mb-1 w-full accent-amber-400 disabled:opacity-40" aria-label="Volume da música" />
      <Row icon={Zap} label="Efeitos sonoros" on={cfg.sfxOn} onToggle={() => { upd({ sfxOn: !cfg.sfxOn }); if (!cfg.sfxOn) wbSfx.click(); }} testid="wb-audio-sfx" />
      <button onClick={() => upd(allOff ? { musicOn: true, sfxOn: true } : { musicOn: false, sfxOn: false })} data-testid="wb-audio-mute-all"
        className="mt-2 flex w-full items-center justify-center gap-1.5 rounded-full border border-purple-500/40 py-1.5 text-[11px] font-black uppercase tracking-widest text-purple-100">
        {allOff ? <><Volume2 className="h-3.5 w-3.5" /> Ligar tudo</> : <><VolumeX className="h-3.5 w-3.5" /> Silenciar tudo</>}
      </button>
    </div>
  );
};
